import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonService } from '@shared/services/common.service';

@Component({
    selector: 'app-tick-icon',
    templateUrl: './tick-icon.component.html',
    styleUrls: ['./tick-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickIconComponent{
    @Input() creatorData: any;
    @Input() cls: string = '';

    constructor(public cs: CommonService) {}
}